import { useSelector } from 'react-redux';

interface DemoContactBoxProps {
    name?: string;
    position?: string;
    phone?: string;
    mobile?: string;
    email?: string;
    emailLink?: string;
    image?: string;
}

export default function DemoContactBox({
    name = '',
    position = '',
    phone = '',
    mobile = '',
    email = '',
    emailLink = '',
    image = '',
}: DemoContactBoxProps) {
    const i18n = useSelector((state: any) => state.i18n.i18n);

    const updatePhoneNumbers = (phone: string) => {
        const phoneNumbers = phone.split(',');
        return phoneNumbers.map((phoneNumber) => {
            return phoneNumber.replaceAll(' ', '').replaceAll('-', '');
        });
    };

    return (
        <div className="text-layout-textcolor flex w-full xl:w-fit gap-10 xl:flex-nowrap flex-wrap justify-center">
            <div>
                <p className="text-2xl">
                    {i18n.translate({
                        id: 'modal.contact.contactPerson',
                        sourceName: 'Demo',
                    })}
                </p>
                {name && <p className="text-sm font-bold">{name}</p>}
                {position && <p className="text-sm">{position}</p>}
                {phone && (
                    <p className="text-sm">
                        T{' '}
                        <span>
                            <a href={`tel:${updatePhoneNumbers(phone)}`}>{phone}</a>
                        </span>
                    </p>
                )}
                {mobile && (
                    <p className="text-sm">
                        M{' '}
                        <span>
                            <a href={`tel:${updatePhoneNumbers(mobile)}`}>{mobile}</a>
                        </span>
                    </p>
                )}
                {email && (
                    <p className="text-sm">
                        <span>
                            <a href={emailLink}>{email}</a>
                        </span>
                    </p>
                )}
            </div>
            {image && (
                <div className="xl:m-auto mr-0 h-[180px] w-[180px] flex justify-end items-center">
                    <div className="h-full w-full rounded-full bg-gray overflow-hidden">
                        <img src={image} alt="" className="h-full w-full object-cover" />
                    </div>
                </div>
            )}
        </div>
    );
}
